module.exports = __webpack_public_path__ + "img/radar.97d6f683.svg";